import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { AdminsAvatarsComponent } from '@core/account-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { JobSkillsSummaryJob, JobSkillSummaryUser } from '@core/positions-and-skills-types';
import { ButtonComponent, DividerComponent, HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-job-skills-summary-details-header',
  templateUrl: './job-skills-summary-details-header.component.html',
  styleUrls: ['./job-skills-summary-details-header.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AdminsAvatarsComponent,
    ButtonComponent,
    DividerComponent,
    HeadingComponent,
    TranslatePipe,
  ],
})
export class JobSkillsSummaryDetailsHeaderComponent {
  public readonly job = input.required<JobSkillsSummaryJob | null>();
  public readonly showJobTitle = input.required<boolean>();
  public readonly interviewResultsCount = input.required<number>();
  public readonly users = input.required<JobSkillSummaryUser[]>();
  public readonly showPositionButton = input.required<boolean>();

  public readonly viewPosition = output();

  protected onViewPosition() {
    this.viewPosition.emit();
  }
}
